// @ts-nocheck
import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";
import { Route } from "react-router-dom";
import Loading from "./components/routecomponents/Loading";

const AuthOProtectedRoute = ({ component: Component, layout: Layout, ...rest }) => {
    const WrappedComponent = withAuthenticationRequired(Component, {
        onRedirecting: () => (
            <div className="page-layout">
                <Loading />
            </div>
        ),
    });

    return (
        <Route
            render={(props) => (
                <Layout>
                    <WrappedComponent {...props} />
                </Layout>
            )}
            {...rest}
        />
    );
};

export default AuthOProtectedRoute;